export interface CourseRouteGroupSlugSource {
  params?: Record<string, unknown>
  query?: Record<string, unknown>
}

function readSlugValue(value: unknown): string {
  if (typeof value === 'string' && value.length > 0) return value
  if (Array.isArray(value) && typeof value[0] === 'string' && value[0].length > 0) return value[0]
  return ''
}

/**
 * Resolves community context `groupSlug` from route params or query (including `group_slug` alias).
 * Matches {@link useCourseBackNavigation} so breadcrumbs and back nav stay aligned.
 */
export function resolveCourseRouteGroupSlug(route: CourseRouteGroupSlugSource): string {
  const fromParams = readSlugValue(route.params?.groupSlug)
  if (fromParams) return fromParams

  const fromQuery = route.query?.groupSlug ?? route.query?.group_slug
  return readSlugValue(fromQuery)
}
